<template>
  <div class="work-preview-wrap">
    <iframe ref="iframe" :src="editorUrl" width="100%" height="100%" class="editor" allow="microphone;camera;midi;encrypted-media;"></iframe>
    <div class="loading-mask" v-if="loading">
      <loading
        :box-size="16"
        :round-size="4"
        :color="'#306FFF'"></loading>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading'
import { get } from '@/utils/ajax'

/**
 * 阅卷【考生模式】
 */
export default {
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      editorUrl: ''
    }
  },
  computed: {
    // 操作题类型
    questionType() {
      return +this.$route.query.questionType
    },
    // 作品加密code
    code() {
      return this.$route.query.code
    }
  },
  methods: {
    // 创建操作题dom节点
    initIframe() {
      this.loading = true
      switch (this.questionType) {
        case 0: // kitten
          this.editorUrl = `${CONFIG.ide}?in_edu_lesson=true`
          break
        case 2: // python
          this.editorUrl = CONFIG.python
          break
        case 3: // scratch
          this.editorUrl = CONFIG.scratch
          break
        case 4:
        case 5:
          this.loadWork()
          break
        case 6: // c++
          this.editorUrl = CONFIG.cplusplus
          break
        case 7: // python_oj
          this.editorUrl = CONFIG.python_oj
          break
      }
    },
    async loadWork() {
      const work = await get('/edu/exams/works/common', { code: this.code }, { ignoreToken: true })
      const iframeWindow = this.$refs.iframe.contentWindow
      switch (this.questionType) {
        case 0: // kitten
          iframeWindow.postMessage({ type: 'load_bcm', content: work }, CONFIG.ide)
          break
        case 3: // scratch
          iframeWindow.postMessage({ type: 'load_sb3', content: work }, CONFIG.scratch)
          break
        case 4: // nemo
          this.editorUrl = `${window.CONFIG.tanyuepigai}/edu?workUrl=${encodeURIComponent(work)}`
          this.loading = false
          break
        case 5: // 闯关题
          this.editorUrl = work
          this.loading = false
          break
        case 2: // python
        case 6: // c++
        case 7: // python_oj
          if (this.questionType === 2) { // python
            iframeWindow.postMessage({ msg: 'set_python_code', code: work }, CONFIG.python)
          } else { // c++ 或 python_oj
            iframeWindow.postMessage({
              type: 'WORK_OPEN',
              payload: {
                work: {
                  work_id: 0,
                  name: '新的作品',
                  extension: this.questionType === 6 ? 'cpp' : 'py',
                  content: work,
                  version: 0
                }
              }
            }, this.questionType === 6 ? CONFIG.cplusplus : CONFIG.python_oj)
          }
          this.loading = false
          break
      }
    },
    // 操作题接收 postMessage 消息
    iframeMessage(e) {
      const message = e.data
      switch (message.type) {
        case 'kitten_loaded': // kitten工具初始化完成
          this.initKitten()
          this.loadWork()
          break
        case 'scratch_loaded': // scratch工具初始化完成
          this.loadWork()
          break
        case 'exam_load_bcm_end': // 加载bcm的结果
          this.loading = false
          if (message.content.content.status === 'error') {
            this.$message.error('加载作品失败')
          }
          break
        case 'exam_load_sb3_end': // 加载sb3的结果
          this.loading = false
          if (message.content.content.status === 'error') {
            this.$message.error('加载作品失败')
          }
          break
        case 'IFRAME_READY': // c++、python_oj工具初始化完成
          this.initTart(message.payload.page)
          this.loadWork()
          break
      }
      switch (message.msg) {
        case 'wood_is_ready': // python初始化完成
          this.initPython()
          this.loadWork()
          break
      }
    },
    // 初始化Tart工具 type= 'py_oj' | 'cpp_oj'
    initTart(type) {
      const tart = this.$refs.iframe
      let domain = '*'
      let exportName = ''
      switch (type) {
        case 'py_oj':
          domain = CONFIG.python_oj
          exportName = 'exportAsPythonFile'
          break
        case 'cpp_oj':
          domain = CONFIG.cplusplus
          exportName = 'exportAsCppFile'
          break
        default:
          throw new Error('未知编辑器')
      }

      if (!tart) return
      const tartWindow = tart.contentWindow

      tartWindow.postMessage(
        {
          type: 'FEATURE_SET_CONFIG',
          payload: {
            headerDisabled: false, // 默认展示头部栏，true 则隐藏
            headerLogoDisabled: true, // 默认展示头部栏中的Logo，true 则隐藏
            headerFileMenuDisabled: false, // 默认展示头部栏中的文件菜单，true 则隐藏
            headerFileMenuItems: [
              // 'createProject',
              // 'openProjectManager',
              // 'workSaveAs',
              // 'divider',
              // 'openLocalFile',
              exportName
              // 'divider',
              // 'importMiaoLink',
              // 'exportAsMiaoLink',
            ], // 默认展示所有头部栏文件菜单选项，[] 则隐藏所有
            userAvatarDisabled: true, // 默认展示用户头像，true 则隐藏
            workSaveButtonDisabled: true, // 默认展示作品保存按钮，true 则隐藏
            workNameInputDisabled: true, // 默认展示作品名称输入框，true 则隐藏
            disabledRegExp: true // 默认隐藏正则配置，false 则展示
          }
        },
        domain
      )
    },
    // 初始化kitten配置项
    initKitten() {
      const kitten = this.$refs.iframe
      if (!kitten) return
      const kittenWindow = kitten.contentWindow
      kittenWindow.postMessage(
        {
          type: 'kitten_set_ui',
          content: {
            header: {
              file: true, // 展示文件按钮
              export_file: true, // 展示保存作品到本地
              setting: true, // 展示设置按钮
              language: true, // 展示语言切换
              save: false // 隐藏保存按钮
            }
          }
        },
        CONFIG.ide
      )
    },
    initPython() {
      const python = this.$refs.iframe
      if (!python) return
      const pythonWindow = python.contentWindow
      // 设为代码模式
      pythonWindow.postMessage({ msg: 'set_default_mode', mode: 'code' }, CONFIG.python)
      // 隐藏切换积木模式按钮
      pythonWindow.postMessage({ msg: 'set_mode_btn_display', mode: 'false' }, CONFIG.python)
      // 隐藏自带的缩放按钮
      pythonWindow.postMessage({ msg: 'set_fullscreen_btn_display', is_display: false }, CONFIG.python)
      // 隐藏帮助按钮
      pythonWindow.postMessage({ msg: 'set_help_btn_display', is_display: false }, CONFIG.python)
      // 打开海龟绘图
      pythonWindow.postMessage({ msg: 'set_turtle_canvas_display', is_display: true }, CONFIG.python)
    }
  },
  mounted() {
    this.initIframe()
    window.addEventListener('message', this.iframeMessage)
  },
  destroyed() {
    window.removeEventListener('message', this.iframeMessage)
  }
}
</script>

<style lang="scss" scoped>
.work-preview-wrap,
.editor {
  width: 100%;
  height: 100%;
  border: 0;
}
.loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 5;
  background-color: rgba(0, 0, 0, .3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
